<template>
  <div class="container">
    <main style="padding: 20px">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        size="small"
        label-position="top"
      >
        <el-card class="card">
          <div slot="header" class="clearfix">
            <strong style="font-size: 14px">资源基本信息</strong>
          </div>
          <div style="width: 300px">
            <el-form-item label="分类名称" prop="name">
              <el-input
                disabled
                v-model="ruleForm.name"
                placeholder="请输入分类名称"
                class="formItemStyle"
              ></el-input>
            </el-form-item>
            <el-form-item label="分类类型" prop="type">
              <el-select
                disabled
                v-model="ruleForm.type"
                placeholder="请选择分类类型"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="默认优先级" prop="priority">
              <el-input
                v-model="ruleForm.priority"
                type="number"
                class="formItemStyle"
              ></el-input>
            </el-form-item>
          </div>
        </el-card>
        <el-card class="card">
          <div slot="header" class="clearfix">
            <strong style="font-size: 14px">选择资源</strong>
          </div>
          <div>
            <el-card class="card">
              <div slot="header" class="clearfix">
                <span style="font-size: 13px">已关联</span>
              </div>
              <div>
                <div class="cardContainer" v-if="linkData.length !== 0">
                  <div
                    v-for="(item, index) in linkData"
                    :key="item.wallpaperId"
                    class="item"
                  >
                    <el-card :body-style="{ padding: '0px' }">
                      <div style="font-size: 0px; padding-top: 10px">
                        <img
                          v-lazy="item.thumbUrl"
                          class="wallpapaerImg"
                        />
                      </div>
                      <div>
                        <span
                          class="content"
                          :style="
                            item.wallpaperType == 'emoji'
                              ? 'font-size:30px'
                              : ''
                          "
                          >{{ item.wallpaperName }}</span
                        >
                      </div>
                      <el-input
                        v-model="item.priority"
                        placeholder="默认优先级"
                        size="mini"
                        type="number"
                        style="width: 110px; margin-bottom: 10px"
                      ></el-input>
                    </el-card>
                    <i
                      class="el-icon-error deleteIcon"
                      @click="deleteData(index)"
                    ></i>
                  </div>
                </div>
                <el-empty :image-size="100" v-else></el-empty>
              </div>
            </el-card>
            <el-card class="card">
              <div slot="header" class="clearfix">
                <span style="font-size: 13px">可关联</span>
              </div>
              <div>
                <div class="linkContainer">
                  <div class="filterContainer">
                    <el-input
                      v-model="searchClassify"
                      placeholder="搜索资源名称"
                      @keyup.enter.native="getClassify"
                      size="small"
                      style="width: 200px"
                    ></el-input>
                    <ResourceTypePicker
                      :value="type"
                      :types="searchOption"
                      :sort-types="!isWallpaperCategory"
                      placeholder="资源类型"
                      style="width: 200px"
                      size="small"
                      @change="onTypeChange"
                    />

                    <el-select
                      v-model="dataSetIds"
                      placeholder="不包含数据集"
                      style="width: 200px"
                      size="small"
                      filterable
                      clearable
                      multiple
                      @change="getClassify"
                    >
                      <el-option
                        v-for="item in dataOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>

                    <el-button
                      type="primary"
                      size="mini"
                      @click="
                        type = '';
                        searchClassify = '';
                        dataSetIds = [];
                        getClassify();
                      "
                      >清空</el-button
                    >
                  </div>
                </div>
                <div class="cardContainer">
                  <el-card
                    :body-style="{ padding: '0px' }"
                    class="item"
                    v-for="(item, index) in disLinkData"
                    :key="item.wallpaperId"
                    @click.native="addData(index)"
                    style="cursor: pointer"
                  >
                    <div style="font-size: 0px; padding-top: 10px">
                      <img
                        v-lazy="item.thumbUrl"
                        class="wallpapaerImg"
                      />
                    </div>
                    <div>
                      <span
                        class="content"
                        :style="
                          item.wallpaperType == 'emoji' ? 'font-size:30px' : ''
                        "
                        >{{ item.wallpaperName }}</span
                      >
                    </div>
                    <i class="el-icon-circle-plus addIcon"></i>
                  </el-card>
                </div>
                <!-- footer -->
                <div class="footerContainer">
                  <div style="color: #a1a1a1">
                    共 {{ total }} 条记录 第 {{ currentPage }} /
                    {{ currentPageSize }} 页
                  </div>
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next,sizes,jumper"
                    :total="total"
                    :page-sizes="[10, 20, 40]"
                    :page-size="currentPageSize"
                    :current-page.sync="currentPage"
                  />
                </div>
              </div>
              <!-- <el-empty :image-size="100" v-else></el-empty> -->
            </el-card>
          </div>
        </el-card>
      </el-form>
    </main>
    <footer class="bottomContainer">
      <div>
        <el-button size="small" @click="back">取消</el-button>
        <el-button type="primary" size="small" @click="submitForm()"
          >保存</el-button
        >
      </div>
    </footer>
  </div>
</template>
<script>
import {
  selectWallpaperPageByCategoryId,
  updateCategoryWallpaper,
} from "../../../api/classifyManage";
import { listAllWallpaperType as listMusicWallpaperType } from "../../../api/genericResource";
import { getAllDataList } from "../../../api/comment";
import { mutations } from "../../../utils/store";
import ResourceTypePicker from "../../resourceManage/genericResourceManage/ResourceTypePicker.vue";
import { toTypeQuery } from "../../resourceManage/genericResourceManage/resourceTypeFilter";

export default {
  name: "resourcesCreate",
  components: { ResourceTypePicker },
  data() {
    return {
      ruleForm: {
        priority: 0,
        name: "",
        type: "",
      },
      rules: {
        name: [
          { required: true, message: "分类名称不能为空", trigger: "blur" },
        ],
        type: [
          { required: true, message: "分类类型不能为空", trigger: "blur" },
        ],
        priority: [
          { required: true, message: "默认优先级不能为空", trigger: "blur" },
        ],
      },
      linkData: [],
      disLinkData: [],
      searchClassify: "",
      currentPage: 1,
      currentPageSize: 10,
      total: 0,
      deleteIds: [],
      dataOptions: [],
      typeOptions: [
        { label: "壁纸", value: 1 },
        { label: "ai_assistant", value: 17 },
        { label: "通用", value: 21 },
      ],
      deleteItem: [],
      searchOption: [],
      type: "",
      dataSetIds: [],
    };
  },
  computed: {
    /** 壁纸分类的类型列表是写死的业务顺序，不按字母重排。 */
    isWallpaperCategory() {
      return this.ruleForm.type == 1 || this.ruleForm.type === "壁纸";
    },
  },
  created() {
    this.setBreadTitle(this.$route.query.name + "-新增");
    this.getFirstList();
    this.getAllDataSet();
  },
  beforeDestroy() {
    this.setBreadTitle(undefined);
  },
  methods: {
    setBreadTitle: mutations.setBreadTitle,
    //获取关联信息列表
    getFirstList() {
      selectWallpaperPageByCategoryId({
        pageNum: this.currentPage,
        pageSize: this.currentPageSize,
        id: this.$route.params.id,
        name: this.searchClassify,
        ...this.typeParams(),
        dataSetIds: [],
      })
        .then((res) => {
          if (res.success) {
            this.ruleForm.name = res.data.categoryName;
            this.ruleForm.type = res.data.categoryType;
            this.linkData = res.data.alreadyConnect;
            this.disLinkData = res.data.canConnect;
            this.total = res.data.total;
          }
        })
        .catch((err) => {
          this.showRequestError(err);
        })
        .finally(() => {
          // categoryType 可能是 ID（1/17/21）或历史字符串名称，需同时兼容
          if (this.ruleForm.type == 1 || this.ruleForm.type === "壁纸") {
            this.searchOption = [
              "静态壁纸资源",
              "视频壁纸资源",
              "4D Parallax壁纸资源",
              "重力壁纸资源",
              "动画壁纸资源",
              "交互壁纸资源",
              "壁纸合集资源",
              "桌面宠物",
              "毛玻璃",
              "时钟壁纸",
              "3d重力",
              "联系人海报资源",
              "游戏壁纸资源",
              "来电秀壁纸资源",
              "实况壁纸资源",
              "unity壁纸",
              "TV屏保",
              "live壁纸",
              "OS26景深壁纸资源",
              "flip",
              "AIGC",
            ];
          } else if (this.ruleForm.type == 17 || this.ruleForm.type === "ai_assistant") {
            this.searchOption = ["ai_assistant"];
          } else if (this.ruleForm.type == 21 || this.ruleForm.type === "通用") {
            // 动态从后端获取通用资源类型
            listMusicWallpaperType()
              .then((res) => {
                if (res.success && res.data) {
                  this.searchOption = res.data;
                }
              })
              .catch((err) => {
                this.showRequestError(err);
              });
          }
        });
    },
    isLinkIn(val) {
      var list = [];
      this.linkData.forEach((e) => {
        list.push(e.wallpaperId);
      });
      return val.filter((element) => {
        return !list.includes(element.wallpaperId);
      });
    },
    getList() {
      selectWallpaperPageByCategoryId({
        pageNum: this.currentPage,
        pageSize: this.currentPageSize,
        id: this.$route.params.id,
        name: this.searchClassify,
        ...this.typeParams(),
        dataSetIds: this.dataSetIds,
      })
        .then((res) => {
          if (res.success) {
            this.disLinkData = this.isLinkIn(res.data.canConnect);
            // console.log(this.disLinkData)
            this.total = res.data.total;
            // if (this.isLastData) {
            //   this.disLinkData = [...this.disLinkData, ...this.deleteItem]
            // }
          }
        })
        .catch((err) => {
          this.showRequestError(err);
        });
    },
    /** 二级筛选的选中值 → 接口的 wallpaperType / wallpaperTypes / stickerKind。 */
    typeParams() {
      const query = toTypeQuery(this.type);
      return {
        type: query.wallpaperType || "",
        wallpaperTypes: query.wallpaperTypes,
        stickerKind: query.stickerKind,
      };
    },
    onTypeChange(value) {
      this.type = value;
      this.getClassify();
    },
    back() {
      this.$router.back(-1);
    },
    getClassify() {
      this.getList();
    },
    addData(index) {
      var item = JSON.parse(JSON.stringify(this.disLinkData[index]));
      item["priority"] = JSON.parse(JSON.stringify(this.ruleForm.priority)) - 0;
      this.linkData.push(item);
      this.disLinkData.splice(index, 1);
      // if (!this.isLinkIn(item)) {
      //   this.linkData.push(item)
      // } else {
      //   this.$message({
      //     type: 'info',
      //     message: '该资源已经存在了,请勿重复添加'
      //   })
      // }
    },
    deleteData(index) {
      var item = this.linkData[index];
      item.priority = "";
      this.linkData.splice(index, 1);
      this.disLinkData.push(item);
      // if (item.id) {
      //   this.deleteIds.push(item.id)
      // }
    },
    //footer-大小改变
    handleSizeChange(val) {
      this.currentPageSize = val;
      this.$nextTick(() => {
        this.getList();
      });
    },
    //footer-当前页数改变
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          updateCategoryWallpaper({
            categoryId: this.$route.params.id,
            defaultPriority: this.ruleForm.priority + "",
            deleteIds: this.deleteIds.join(","),
            data: this.linkData,
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  type: "success",
                  message: "修改成功",
                });
                this.back();
              }
            })
            .catch((err) => {
              this.showRequestError(err);
            });
        } else {
          this.$message.error("你还有参数没有填完整");
          return false;
        }
      });
    },
    getAllDataSet() {
      getAllDataList()
        .then((res) => {
          if (res.success) {
            this.dataOptions = res.data;
          }
        })
        .catch((err) => {
          this.showRequestError(err);
        });
    },
    showRequestError(err) {
      // 拦截器会把业务错误 reject 出来；这里兜底展示可读文案，避免未处理 Promise 留在控制台。
      const message =
        (err && (err.errMessage || err.message)) || "请求失败，请稍后重试";
      this.$message({
        type: "error",
        message,
      });
    },
  },
};
</script>
<style scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.formItemStyle {
  width: 100%;
}

.bottomContainer {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  box-shadow: 0px 2px 5px #888;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 20px;
}

.card {
  margin-bottom: 20px;
}

.fontBackgroundColor {
  background-color: black;
}

.wallpapaerImg {
  object-fit: cover;
  max-height: 100px;
  max-width: 170px;
}

.cardContainer {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 10px;
}

.logoImage {
  width: 20px;
  cursor: pointer;
}

.cardTextItem {
  height: 100px;
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  white-space: pre;
}

.item {
  width: 170px;
  text-align: center;
  margin: 20px 20px 20px 0;
  position: relative;
}

.content {
  font-size: 12px;
  color: grey;
}

.addIcon {
  font-size: 20px;
  color: greenyellow;
  cursor: pointer;
}

.deleteIcon {
  font-size: 20px;
  color: red;
  cursor: pointer;
  position: absolute;
  top: -6px;
  right: -6px;
}

.footerContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.linkContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.linkContainer .filterContainer {
  display: grid;
  grid-template-columns: repeat(auto-fill, 210px);
  grid-gap: 10px;
  grid-template-rows: auto;
  width: 95%;
}

.cardTextItem {
  height: 100px;
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  white-space: pre;
}

.fontItemBackground {
  background-color: black;
}
</style>
